import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueMeta from 'vue-meta'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHashtag, faInbox, faSearch, faCameraRetro } from '@fortawesome/free-solid-svg-icons'
import { faStickyNote } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/css/animate.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/css/w3.css'
import '@/css/app.css'

library.add(faHashtag)
library.add(faInbox)
library.add(faSearch)
library.add(faStickyNote)
library.add(faCameraRetro)

Vue.use(VueMeta)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)

window.blockstack = require('blockstack')
window.axios = require('axios')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
